<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="home">Dashboard</router-link>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <!--<ul class="nav navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>
          </li>
          <base-dropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </base-dropdown>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li>
        </ul>-->
        <ul class="navbar-nav ml-auto">
          <!--<li class="nav-item">
            <router-link class="nav-link" to="overview">
              {{me}}
            </router-link>
          </li>-->
          <base-dropdown :title="'Usuario: '+me">
            <router-link class="dropdown-item" :to="{ name: 'meuperfil'}">Perfil</router-link>
            <div class="divider"></div>
            <a class="dropdown-item cor-deslogar" @click.prevent="logout" style="cursor: pointer;">Sair</a>
          </base-dropdown>
          <li class="nav-item">
            <!--<a type="button" class="nav-link" @click.prevent="logout">
              
            </a>-->
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import axios from 'axios';
  import store_cidadao from "src/storeCidadao.js"
  import 'src/controller/loginController.js'

  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false,
        me:null,
      }
    },
    methods: {
      async logout(){
        let data = await this.$logout();
        this.$router.push('/login');
      },
      async meuLogin(){
        this.me = store_cidadao.nome;
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      }
    },
    beforeMount(){
      try {
        this.meuLogin();
      } catch (e) {
        throw e;
      }
    }
  }

</script>
<style>
   .cor-deslogar{
     color: rgb(208 20 31) !important;
   }
</style>
